import { objectSchemaOf, Joi } from '../helpers';
import type { ISnapshotMeta } from './snapshotMeta';
import { snapshotMetaSchema } from './snapshotMeta';

export interface ISaveSnapshotParams {
  meta: ISnapshotMeta;
  base64Image: string;
}

export const saveSnapshotParamsSchema = objectSchemaOf<ISaveSnapshotParams>({
  meta: snapshotMetaSchema.required(),
  base64Image: Joi.string().base64().required(),
});
